module.exports = ENV;


//////////////////
// WEBPACK FOOTER
// external "ENV"
// module id = 35
// module chunks = 1